module.exports = __webpack_public_path__ + "img/mobile_map_mateu.49a78776.svg";